module.exports = __webpack_public_path__ + "img/renewalTap.887063c6.png";